import dayjs from '@/lib/dayjs'

export default function RoundDisplay({ round }) {
  return (
    <div className="w-full">
      <div className="divide bg-neutral-blue-700"></div>
      <p className="pb-2 pt-5 text-center text-p-2 font-semibold">
        {round?.track}
      </p>
      <p className="text-center text-p-2 text-neutral-blue-500">
        {dayjs(round.event_date).format('DD MMMM YYYY')}
      </p>
    </div>
  )
}
